import { render, staticRenderFns } from "./dj-view-relative.vue?vue&type=template&id=417d7a6e&scoped=true&"
import script from "./dj-view-relative.vue?vue&type=script&lang=js&"
export * from "./dj-view-relative.vue?vue&type=script&lang=js&"
import style0 from "./dj-view-relative.vue?vue&type=style&index=0&id=417d7a6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417d7a6e",
  null
  
)

export default component.exports